<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <form class="form-inline">
            <input
              v-model="ShowDateStart"
              @change="loadData()"
              type="date"
              class="form-control"
              title="Start Date"
            />

            <input
              v-model="ShowDateEnd"
              @change="loadData()"
              type="date"
              class="form-control"
              title="End Date"
            />

            <select
              v-model="ChannelCode"
              @change="loadData()"
              class="form-control"
              id="ChannelCode"
              title="Channel"
            >
              <option value>Channel</option>
              <option
                v-for="channel in Channels"
                :value="channel.Number"
                :key="channel.Number"
              >{{channel.Name}} {{channel.Number}}</option>
            </select>
          </form>
        </div>
      </div>
    </div>

    <br />

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Time</th>
          <th
            v-for="ShowTime in ShowTimeHeader"
            :key="ShowTime.ShowTimeISO"
            :title="ShowTime.ShowTime"
          >{{ShowTime.ShowTimeStr}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in Rows" :key="row.Channel.Number">
          <td>
            <router-link
              :to="{name:'masterdetailselected', params:{chcode: row.Channel.Number}}"
            >{{row.Channel.Name}} {{row.Channel.Number}}</router-link>
          </td>
          <td v-for="cell in row.Cells" :key="cell.Show.DateStart" :colspan="cell.Span">
            <span>{{cell.Show.Title}}</span>
            <br />
            <span
              v-if="!!cell.Show.Channel"
            >{{cell.Show.ChannelNumber}}: {{cell.Show.DateStartStr}} - {{cell.Show.DateEndStr}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import API from "../apis/firstmedia.js";
import _ from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      ShowDateStart: moment()
        .add(-6, "days")
        .format("YYYY-MM-DD"),
      ShowDateEnd: moment().format("YYYY-MM-DD"),
      ChannelCode: "",
      Channels: [],
      ServerResponse: {}
    };
  },
  computed: {},
  async created() {
    let spinnerToken = await this.$store.dispatch("spinner/needSpinner");
    let response = await API.getChannel();
    this.$store.dispatch("spinner/dontNeedSpinner", spinnerToken);
    this.Channels = _.sortBy(response.Channels, ["Name", "Number"]);
  },
  methods: {
    async loadData() {
      let dateStart = moment(this.ShowDateStart).toISOString();
      let dateEnd = moment(this.ShowDateEnd)
        .add(1, "days")
        .toISOString();
      let channelNumbers = [Number(this.ChannelCode)];

      let spinnerToken = await this.$store.dispatch("spinner/needSpinner");
      this.ServerResponse = await API.getSchedule(
        channelNumbers,
        dateStart,
        dateEnd
      );
      this.$store.dispatch("spinner/dontNeedSpinner", spinnerToken);
    }
  }
};
</script>